export enum QuoteType {
  Single = 'single',
  Rollout = 'rollout',
  SubQuote = 'sub-quote',
  LinkedGroup = 'linked-group',
  LinkedSubQuote = 'linked-sub-quote',
}
